/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rscu_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Above 1 means the codon is used more than expected (over-represented or preferred); below 1 means it is used less than expected (under-represented). Exactly 1 means it matches the unbiased expectation.`)
};

const es_rscu_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por encima de 1 significa que el codón se usa más de lo esperado (sobrerrepresentado o preferido); por debajo de 1 significa que se usa menos de lo esperado (subrepresentado). Exactamente 1 significa que coincide con la expectativa sin sesgo.`)
};

const de_rscu_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über 1 bedeutet, dass das Codon häufiger verwendet wird als erwartet (überrepräsentiert oder bevorzugt); unter 1 bedeutet, dass es seltener verwendet wird als erwartet (unterrepräsentiert). Genau 1 bedeutet, dass es der unverzerrten Erwartung entspricht.`)
};

const nl_rscu_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boven 1 betekent dat het codon meer wordt gebruikt dan verwacht (oververtegenwoordigd of begunstigd); onder 1 betekent dat het minder wordt gebruikt dan verwacht (ondervertegenwoordigd). Precies 1 betekent dat het overeenkomt met de onbevooroordeelde verwachting.`)
};

const fr_rscu_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supérieur à 1 signifie que le codon est utilisé plus que prévu (surreprésenté ou préféré) ; inférieur à 1 signifie qu'il est utilisé moins que prévu (sous-représenté). Exactement 1 signifie qu'il correspond à l'attente non biaisée.`)
};

const it_rscu_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sopra 1 significa che il codone è usato più del previsto (sovra-rappresentato o preferito); sotto 1 significa che è usato meno del previsto (sotto-rappresentato). Esattamente 1 significa che corrisponde all'aspettativa senza bias.`)
};

const pt_br2_rscu_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acima de 1 significa que o códon é usado mais do que o esperado (super-representado ou preferido); abaixo de 1 significa que é usado menos do que o esperado (sub-representado). Exatamente 1 significa que corresponde à expectativa sem viés.`)
};

const pt_rscu_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acima de 1 significa que o codão é usado mais do que o esperado (sobrerrepresentado ou preferido); abaixo de 1 significa que é usado menos do que o esperado (subrrepresentado). Exatamente 1 significa que corresponde à expectativa sem viés.`)
};

const ja_rscu_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1を超えると、そのコドンは期待より多く使われている（過剰使用または優先されている）ことを意味します。1未満は、期待より少なく使われている（過小使用）ことを意味します。ちょうど1であれば、偏りのない期待値と一致します。`)
};

const zh_rscu_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高于 1 表示该密码子的使用频率高于预期（过度使用或受偏好）；低于 1 表示使用频率低于预期（使用不足）。恰好为 1 表示与无偏预期一致。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rscu_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rscu_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rscu_faq_a3", locale)
	if (locale === "en") return en_rscu_faq_a3(inputs)
	if (locale === "es") return es_rscu_faq_a3(inputs)
	if (locale === "de") return de_rscu_faq_a3(inputs)
	if (locale === "nl") return nl_rscu_faq_a3(inputs)
	if (locale === "fr") return fr_rscu_faq_a3(inputs)
	if (locale === "it") return it_rscu_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_rscu_faq_a3(inputs)
	if (locale === "pt") return pt_rscu_faq_a3(inputs)
	if (locale === "ja") return ja_rscu_faq_a3(inputs)
	return zh_rscu_faq_a3(inputs)
};